import React, {PureComponent} from "react"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

interface Props extends InjectIntl {
  value: string
  onChange?: (value: string) => void
  onBlur?: (value: string) => void
  validation?: () => any
  label?: string
}

class Email extends PureComponent<Props> {
  buildEmailSchema = () => {
    return Validation.string("platform.defaultValidation.required").email("platform.fields.email.valid").max(255)
  }

  render() {
    const {validation, formatMessage, label = "platform.fields.email.label", ...props} = this.props

    return (
      <Input type="email" name="email" label={formatMessage({id: label})} {...props} validation={validation || this.buildEmailSchema()} />
    )
  }
}

export default injectIntl(Email)
